export default __webpack_public_path__ + "static/media/credit_cards.cbd1ed59.pdf";